import * as Sentry from "@sentry/vue";
import { createRouter, createWebHistory, type Router } from "vue-router";

import { usePageStore } from "~/stores";

import { checkNavigationRules } from "./common";
import ROUTES from "./routes";

const router: Router = createRouter({
  history: createWebHistory(""),
  routes: ROUTES,
});

router.beforeEach((to, from) => {
  if (!usePageStore().userDataLoaded) {
    return true;
  }
  return checkNavigationRules(to, from);
});

router.onError((error: Error) => {
  if (error.message.includes("Failed to fetch dynamically imported module")) {
    Sentry.captureException(error);
    // eslint-disable-next-line no-alert
    if (window.confirm("Dart didn’t load correctly. Please reload the page.")) {
      window.location.reload();
    }
  }
});

export default router;
